export const version = {  number: '1.0.0' };
